import { createContext, useState, useEffect } from 'react';

const RecipientContext = createContext();

const RecipientProvider = ({ children }) => {
    const [recipient, setRecipient] = useState(null);
    
    return (
        <RecipientContext.Provider value={[recipient, setRecipient]}>
            {children}
        </RecipientContext.Provider>
    )
}

export { RecipientContext, RecipientProvider };